/*
 * Copyright © 2025. Legalbird eine Marke der Legalbird GmbH
 */

import React from "react";
import { Button } from "@mui/material";
import flexAiChatAgentStyle from "./FlexAiChatAgentStyle";
import { getFlexLpConfigByAiAnswer } from "../../../../../services/advocardService";
import { AdvocardFlexAiResponse } from "../../../../../types/AdvocardFlexAiResponse";

type FlexAiChatAgentCTAButtonProps = {
  aiResponse: AdvocardFlexAiResponse;
  createCase: Function;
  isLoading: boolean;
};

export default function FlexAiChatAgentCTAButton({ aiResponse, createCase, isLoading }: FlexAiChatAgentCTAButtonProps) {
  if (aiResponse.isQuestionCurrentFlexServiceRelated) {
    return (
      <Button onClick={() => createCase()} variant={"contained"} sx={flexAiChatAgentStyle.button} fullWidth={true} disabled={isLoading}>
        Erstberatung buchen
      </Button>
    );
  }

  return aiResponse.predictedLegalProduct && getFlexLpConfigByAiAnswer(aiResponse, createCase, isLoading).predictedLegalProductButton;
}
